var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDroneLand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "orange",
    d: "M36.8,320.5c6,0,12,1.5,17.6,4.5l199.5,109.5L458,325.6c17.9-9.5,40.1-2.8,49.7,15.1 c9.5,17.9,2.8,40.1-15.1,49.7L274.5,506.8c-13,7.1-29.4,7-42.6-0.5L19.1,389.4c-17.8-9.8-24.3-32.1-14.5-49.9 C11.2,327.3,23.8,320.5,36.8,320.5z M239.5,442.2l0.7-0.4C239.9,441.9,239.7,442.1,239.5,442.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "offwhite",
    d: "M503.7,14.1H433v-3.5c0-5.3-4.7-10-10-10s-10,4.7-10,10v3.5h-72.6c-5.3,0-10,4.7-10,10c0,5.3,4.7,10,10,10H413 v5.3c-10,3.5-17.7,13.6-17.7,24.8v5.3h-43.1c-4.1-11.8-15.3-20.1-28.3-20.1h-134c-13,0-24.2,8.3-28.3,20.1h-43.1v-5.3 c0-11.2-7.1-20.6-17.1-24.8v-5.9h70.8c5.3,0,10-4.7,10-10s-4.7-10-10-10h-70.8V10c0-5.3-4.7-10-10-10C86.1,0,82,5.3,82,10.6v3.5H10 c-5.3,0-10,4.7-10,10c0,5.3,4.7,10,10,10h72V40c-10,4.1-17.1,13.6-17.1,24.8v31.3c0,14.7,11.8,26.5,26.5,26.5s26.5-11.8,26.5-26.5 v-5.9H161c4.1,11.8,15.3,20.1,28.3,20.1v24.2c0,1.2,0,2.9,0,4.1c-10.6,2.4-24.2,10-30.1,29.5l-18.3,69h-9.4c-5.3,0-10,4.7-10,10 s4.7,10,10,10h37.2c5.3,0,10-4.7,10-10s-4.7-10-10-10h-7.1l16.5-63.7c4.1-13,12.4-15.9,16.5-15.9c8.3,15.9,25.4,27.1,44.8,27.1h32.4 c19.5,0,36.6-11.2,44.8-27.1c4.7,0.6,12.4,2.9,16.5,15.3l17.1,63.7h-7.1c-5.3,0-10,4.7-10,10c0,5.3,4.7,10,10,10h37.2 c5.3,0,10-4.7,10-10c0-5.3-4.7-10-10-10H371l-18.3-69.6c-5.9-19.5-19.5-27.1-30.1-29.5c0-1.2,0-2.9,0-4.1v-23 c13,0,24.2-8.3,28.3-20.1H394v5.9c0,14.7,11.8,26.5,26.5,26.5S447,110.8,447,96.1V64.8c0-11.2-6.5-20.6-15.9-24.8v-5.9H502 c5.3,0,10-4.7,10-10S509.1,14.1,503.7,14.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDroneLand);
export default __webpack_public_path__ + "static/media/icon_droneLand.7d0a2300c5860067cd4e01bfcd2769c3.svg";
export { ForwardRef as ReactComponent };